/**
 * Escapes double quotes in a label for safe interpolation into
 * `<Context label="...">` attributes. Uses HTML entity encoding.
 */
export function escapeContextLabel(label: string): string {
  return label.replace(/"/g, '&quot;')
}

export const TRIP_PLANNER_ACTION_CONTEXT_LABEL = 'Trip planner action'

/**
 * Appends a single `<Context>...</Context>` block to a visible message while
 * safely escaping the context label for attribute interpolation.
 */
export function appendContextTag(
  message: string,
  contextMessage: string,
  label: string,
): string {
  return `${message}\n<Context label="${escapeContextLabel(label)}">${contextMessage}</Context>`
}

/**
 * Decodes `&quot;` entities back to double quotes when extracting
 * a label from a `<Context label="...">` attribute.
 */
export function unescapeContextLabel(label: string): string {
  return label.replace(/&quot;/g, '"')
}

/** Matches `<Context ...>...</Context>` blocks including an optional leading newline. */
const CONTEXT_TAG_REGEX = /\n?<Context[^>]*>[\s\S]*?<\/Context>/gi

/**
 * Strips all `<Context>...</Context>` blocks from a message string.
 * These blocks carry metadata for the LLM (hotel info, highlighted text, etc.)
 * and should be hidden from users in non-dev mode.
 */
export function stripContextTags(text: string): string {
  return text.replace(CONTEXT_TAG_REGEX, '').trim()
}
